import { RegistrationStatus } from '@r-and-a-shared-ui/utils';

const registrationStatusMap: {
  numeric: Record<number, string>;
  string: Record<string, string>;
} = {
  numeric: {
    0: 'Pending',
    1: 'Approved',
    2: 'Cancelled',
    3: 'Invited',
    4: 'More Info Requested',
  },
  string: {
    [RegistrationStatus.NotRegistered]: 'Not Registered',
    [RegistrationStatus.PreRegistrationComplete]: 'Pre-Registration Complete',
    [RegistrationStatus.Registered]: 'Registered',
  },
};

const getRegistrationStatusLabel = (value: number | string) => {
  if (typeof value === 'number')
    return registrationStatusMap.numeric[value] ?? '';

  return registrationStatusMap.string[value] ?? '';
};

export { getRegistrationStatusLabel };
